module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section--shop c-loading-section",
    class: {
      'c-loading-section--loaded': _vm.shopLoaded,
      'o-shop--post-load': _vm.videoShowing,
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "o-section__max-w"
  }, [_c('div', {
    staticClass: "c-shop__filter"
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "value": "value",
      "clearable": false,
      "options": _vm.metals
    },
    model: {
      value: (_vm.metal),
      callback: function($$v) {
        _vm.metal = $$v
      },
      expression: "metal"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "o-shop-items"
  }, [_vm._l((_vm.rings), function(ring) {
    return _c('li', {
      key: ring.id,
      staticClass: "o-shop-items__item",
      attrs: {
        "id": ring.id
      },
      on: {
        "mouseleave": function($event) {
          _vm.shopItemHoverRemove(
            ring.id,
            ring.variations[ring.variationIndex].guid
          )
        },
        "mouseenter": function($event) {
          _vm.shopItemHover(
            ring.id,
            ring.variations[ring.variationIndex].guid
          )
        }
      }
    }, [_c('a', {
      staticClass: "o-shop-item",
      attrs: {
        "href": '/product/' + ring.id
      },
      on: {
        "click": function($event) {
          _vm.goToDetails($event, ring)
        }
      }
    }, [_vm._l((ring.variations), function(variation, index) {
      return _c('div', {
        key: variation.guid,
        staticClass: "o-shop__video",
        class: {
          'o-shop__video--active':
          index == ring.variationIndex,
        }
      }, [_c('div', {
        staticClass: "o-shop-item__image-carousel"
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (
            variation.videoPlaceholder != null
          ),
          expression: "\n                                        variation.videoPlaceholder != null\n                                    "
        }]
      }, [_c('video', {
        staticClass: "c-shop__video",
        class: {
          'js-video-started':
          index ==
            ring.variationIndex,
        },
        attrs: {
          "oncanplay": "this.muted=true",
          "muted": "",
          "id": 'video-' + variation.guid,
          "loop": "",
          "src": variation.videoSrc
        }
      }, [_c('source', {
        attrs: {
          "type": "video/mp4"
        }
      })])]), _vm._v(" "), _c('span', {
        staticClass: "c-loading-block"
      })]), _vm._v(" "), _c('h1', {
        staticClass: "o-shop-item__title",
        domProps: {
          "textContent": _vm._s(ring.name)
        }
      })])
    }), _vm._v(" "), _c('h2', {
      staticClass: "o-shop-item__price"
    }, [_vm._v("\n                            " + _vm._s(ring.variations[ring.variationIndex].price[
      _vm.$store.state.currency
    ].formatted) + "\n                        ")])], 2)])
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "o-shop-items__container"
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "c-2d__pagination c-2d__pagination--shop"
  }, [_c('span', {
    staticClass: "c-2d__page-number c-2d__page-number--edge",
    class: {
      'c-2d__page-number--active': _vm.currentIndex == 2,
        'c-2d__page-number--inactive': _vm.currentIndex != 2,
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-2d__page-number c-2d__page-number--center",
    class: {
      'c-2d__page-number--active': _vm.currentIndex == 0,
        'c-2d__page-number--inactive': _vm.currentIndex != 0,
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-2d__page-number c-2d__page-number--edge",
    class: {
      'c-2d__page-number--active': _vm.currentIndex == 1,
        'c-2d__page-number--inactive': _vm.currentIndex != 1,
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "o-shop-item__icon o-shop-item__icon--prev",
    on: {
      "click": function($event) {
        _vm.goNext()
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "o-shop-item__icon o-shop-item__icon--next",
    on: {
      "click": function($event) {
        _vm.goPrev()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63494e6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop.vue
// module id = 395
// module chunks = 0